<template>
  <div>
    <p class="cp-help-text">Please enter the shipping address where the order should be delivered. The country and state can be changed in the previous step. The mail and the phone number will only be used by the shipping carrier in case of delivery issues.</p>

    <div class="columns">
      <div class="column is-12-mobile is-7 is-7-desktop cp-left-column">
        <template>
          <br>
          <section>
            <b-field label="Company"
                     :type="{'is-danger': errors.has('shipping_address_form.company')}"
                     :message="errors.first('shipping_address_form.company')">
              <b-input
                      v-validate="'company'"
                      data-vv-scope="shipping_address_form"
                      v-model="reorderData.shippingAddress.company"
                      name="company"
                      @keydown.native="onKeyDownCharsFilterNumbersAndLetters($event, ' ')"></b-input>
            </b-field>
          </section>
        </template>

        <template>
          <br>
          <section>
            <b-field label="First name"
                     custom-class="required-field"
                     :type="{'is-danger': errors.has('shipping_address_form.first name')}"
                     :message="errors.first('shipping_address_form.first name')">
              <b-input
                      v-model="reorderData.shippingAddress.firstName"
                      v-validate="'required|person_name'"
                      data-vv-scope="shipping_address_form"
                      name="first name"
                      @keydown.native="onKeyDownCharsFilterOnlyLetters($event, [' ', '.', '-', '\''])"></b-input>
            </b-field>
          </section>
        </template>

        <template>
          <br>
          <section>
            <b-field label="Last name"
                     custom-class="required-field"
                     :type="{'is-danger': errors.has('shipping_address_form.last name')}"
                     :message="errors.first('shipping_address_form.last name')">
              <b-input
                      v-model="reorderData.shippingAddress.lastName"
                      v-validate="'required|person_name'"
                      data-vv-scope="shipping_address_form"
                      name="last name"
                      @keydown.native="onKeyDownCharsFilterOnlyLetters($event, [' ', '.', '-', '\''])"></b-input>
            </b-field>
          </section>
        </template>

        <template>
          <br>
          <section>
            <b-field label="Street"
                     custom-class="required-field"
                     :type="{'is-danger': errors.has('shipping_address_form.street1')}"
                     :message="errors.first('shipping_address_form.street1')">
              <b-input
                      v-model="reorderData.shippingAddress.street1"
                      v-validate="'required|street'"
                      data-vv-scope="shipping_address_form"
                      name="street1"
                      @keydown.native="onKeyDownCharsFilterNumbersAndLetters($event, ['.', ',', '-', ' ', '/', '\''])"></b-input>
            </b-field>
          </section>
        </template>

        <template>
          <br>
          <section>
            <b-field label="Street 2"
                     :type="{'is-danger': errors.has('shipping_address_form.street2')}"
                     :message="errors.first('shipping_address_form.street2')">
              <b-input
                      v-model="reorderData.shippingAddress.street2"
                      v-validate="'street2'"
                      data-vv-scope="shipping_address_form"
                      name="street2"
                      @keydown.native="onKeyDownCharsFilterNumbersAndLetters($event, ['.', ',', '-', ' ', '/', '\''])"></b-input>
            </b-field>
          </section>
        </template>

        <template>
          <br>
          <section>
            <b-field label="Zip"
                     :type="{'is-danger': errors.has('shipping_address_form.zip')}"
                     :custom-class="this.zipIsRequired() ? 'required-field' : ''"
                     :message="errors.first('shipping_address_form.zip')">
              <b-input v-model="reorderData.shippingAddress.zip"
                       v-validate="this.zipIsRequired() ? 'required|zip_code' : 'zip_code'"
                       data-vv-scope="shipping_address_form"
                       name="zip"
                       @keydown.native="onKeyDownCharsFilterNumbersAndLettersLatin($event, [' ', '-'])"></b-input>
            </b-field>
          </section>
        </template>

        <template>
          <br>
          <section>
            <b-field label="City"
                     :type="{'is-danger': errors.has('shipping_address_form.city')}"
                     custom-class="required-field"
                     :message="errors.first('shipping_address_form.city')">
              <b-input v-model="reorderData.shippingAddress.city"
                       v-validate="'required|city'"
                       data-vv-scope="shipping_address_form"
                       name="city"
                       @keydown.native="onKeyDownCharsFilterOnlyLetters($event, [' ', '.', '-', '\''])"></b-input>
            </b-field>
          </section>
        </template>

        <template>
          <br>
          <section>
            <b-field label="Country">
              <b-input :value="$store.getters['cpReorder/countryName']" disabled></b-input>
            </b-field>
          </section>
        </template>

        <template v-if="reorderData.stateIsRequired">
          <br>
          <section>
            <b-field label="State">
              <b-input :value="$store.getters['cpReorder/stateName']" disabled></b-input>
            </b-field>
          </section>
        </template>

        <template>
          <br>
          <section>
            <b-field label="Email - For contact regarding shipping"
                     custom-class="required-field"
                     :type="{'is-danger': errors.has('shipping_address_form.email')}"
                     :message="errors.first('shipping_address_form.email')">
              <b-input v-model="reorderData.shippingAddress.email"
                       v-validate="'required|email'"
                       data-vv-scope="shipping_address_form"
                       name="email"
                       type="email">
                       </b-input>
            </b-field>
          </section>
        </template>

        <template>
          <br>
          <section>
            <b-field label="Phone number - For contact regarding shipping"
                     custom-class="required-field"
                     :type="{'is-danger': errors.has('shipping_address_form.phone number')}"
                     :message="errors.first('shipping_address_form.phone number')">
              <b-input v-model="reorderData.shippingAddress.phone"
                       data-vv-scope="shipping_address_form"
                       name="phone number"
                       @keydown.native="onKeyDownCharsFilterOnlyNumbers($event, ['+', 'Backspace'])"></b-input>
            </b-field>
          </section>
        </template>

        <template v-if="this.$store.getters['cpReorder/customerIdentificationIsSupported']">
          <br>
          <section>
            <b-field label="Customer identification">
              <b-input v-model="reorderData.shippingAddress.customerIdentification"
                       name="customer identification"
                       @keydown.native="onKeyDownCharsFilterNumbersAndLetters($event, [' ', '.', '-', '\''])">
              </b-input>
            </b-field>
          </section>
        </template>
      </div>

      <div class="column is-12-mobile is-5 is-5-desktop cp-right-column-overview">
        <OrderOverview :priceCheck="reorderData.priceCheckResponse" />
      </div>
    </div>
  </div>
</template>

<script>
import OrderOverview from '@/components/reorder/OrderOverview'
import AddressMixin from '@/mixins/AddressMixin'
import InputFieldMixin from '@/mixins/InputFieldMixin'
import ProductShippingValidator from '@/validators/ProductShippingValidator'

export default {
  name: 'StepTwo',
  mixins: [AddressMixin, InputFieldMixin],
  components: {
    OrderOverview
  },

  data () {
    return {
      reorderData: {}
    }
  },

  created () {
    const validator = new ProductShippingValidator()
    validator.create()

    this.reorderData = this.$store.getters['cpReorder/allData']
  }
}
</script>
